import { createSlice } from '@reduxjs/toolkit'

const formSlice = createSlice({
  name: 'form',
  initialState: {
    formIsValid: false,
    firstName: '',
    lastName: '',
    email: '',
    country: 'none',
    phone: '',
    additionalRequest: '',
    firstNameTouched: false,
    lastNameTouched: false,
    emailTouched: false,
    countryTouched: false,
    phoneTouched: false,
    firstNameIsValid: null,
    lastNameIsValid: null,
    emailIsValid: null,
    countryIsValid: null,
    phoneIsValid: null,
    sumbitForm: false,
  },
  reducers: {
    setAdditionalRequest(state, action) {
      const userInput = action.payload
      state.additionalRequest = userInput.additionalRequest
    },
    setSubmitForm(state) {
      state.sumbitForm = true
    },
    setFormIsValid(state) {
      const inputsTouched =
        state.firstNameTouched &&
        state.lastNameTouched &&
        state.emailTouched &&
        state.countryTouched;

      const inputsValid =
        state.firstNameIsValid &&
        state.lastNameIsValid &&
        state.emailIsValid &&
        state.countryIsValid;

      state.formIsValid = inputsTouched && inputsValid;

      // Mark all as touched on final check
      state.firstNameTouched = true;
      state.lastNameTouched = true;
      state.emailTouched = true;
      state.countryTouched = true;
      state.phoneTouched = true;
    },

    setFirstName(state, action) {
      const userInput = action.payload
      state.firstName = userInput.firstName
      state.firstNameIsValid = userInput.firstName.length > 0
    },
    setLastName(state, action) {
      const userInput = action.payload
      state.lastName = userInput.lastName
      state.lastNameIsValid = userInput.lastName.length > 0
    },
    setEmail(state, action) {
      const userInput = action.payload
      state.email = userInput.email
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      state.emailIsValid = re.test(String(userInput.email).toLowerCase())
    },
    setCountry(state, action) {
      const userInput = action.payload
      state.country = userInput.country
      state.countryIsValid = userInput.country !== 'none'
    },
    setPhone(state, action) {
      const rawInput = action.payload.phone;
      const cleanedPhone = rawInput.replace(/[^\d+]/g, '');
      state.phone = cleanedPhone;

      // ✅ Allow empty OR valid format starting with + or 0
      const phoneRegex = /^(\+|0)[0-9]{7,14}$/;
      state.phoneIsValid = cleanedPhone === '' || phoneRegex.test(cleanedPhone);
    },
    setFirstNameTouched(state) {
      state.firstNameTouched = true
    },
    setLastNameTouched(state) {
      state.lastNameTouched = true
    },
    setEmailTouched(state) {
      state.emailTouched = true
    },
    setCountryTouched(state) {
      state.countryTouched = true
    },
    setPhoneTouched(state) {
      state.phoneTouched = true
    },
  },
})

export const formActions = formSlice.actions
export default formSlice
